import {z} from '@hono/zod-openapi';

import {priceReportArgumentSchema} from './PriceReportArgumentSchema';
import {priceReportObjectionSchema} from './PriceReportObjectionSchema';

export const priceReportArgumentSetSchema = z
  .object({
    headline: z.string(),
    arguments: z.array(priceReportArgumentSchema),
    objections: z.array(priceReportObjectionSchema),
  })
  .openapi('PriceReportArgumentSet');

export type PriceReportArgumentSet = z.infer<typeof priceReportArgumentSetSchema>;
